export default __webpack_public_path__ + "static/media/launch1.d0640c95.gif";